//angular
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
//app
import { AppAnimations } from '../../../../_shared/animations';
import { VisibleState } from 'src/app/app.data';
import { KeyName } from 'src/app/app.keynames';
import { StorageService } from '../../../../_core/services';
import { DialogAccountSettingsComponent } from '../dialog/account-settings/account-settings.component';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/_core/services/auth.service';

@Component({
  animations: [AppAnimations],
  selector: 'panel-account',
  templateUrl: './panel-account.component.html'
})

export class PanelAccountComponent implements OnInit {
  companyName: string;
  dialogConfirmation: MatDialogRef<DialogAccountSettingsComponent>;
  status: boolean = false;
  statusPanel: VisibleState =  VisibleState.isHidden;
  userEmail: string;
  userFirstName: string;
  userLastName: string;
  userPicture: string;
  userRole: string;
  subscription: Subscription;

  @Input() _toggleSideNav: boolean = false;
  @Input() _visibleState = VisibleState;

  constructor(
    private _auth: AuthService,
    private _dialog: MatDialog,
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    private _storage: StorageService
  ) {
    this._iconRegistry.addSvgIcon('ico-account', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-customers-02.svg'));
    this._iconRegistry.addSvgIcon('ico-rocket', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-rocket-02.svg'));
    this._iconRegistry.addSvgIcon('ico-settings', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-settings-02.svg'));
    this._iconRegistry.addSvgIcon('ico-signout', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-logout-01.svg'));
    this._iconRegistry.addSvgIcon('ico-switch', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-switch-01.svg'));

    this.companyName = this._storage.readLocalStorage('entityName');
    this.userEmail = this._storage.readLocalStorage('userEmail');
    this.userFirstName = (this._storage.readLocalStorage('userFirstName') != 'null' ? this._storage.readLocalStorage('userFirstName') : '');
    this.userLastName = (this._storage.readLocalStorage('userLastName') != 'null' ? this._storage.readLocalStorage('userLastName') : '');
    this.userPicture = this._storage.readLocalStorage('userAvatar');
    this.userRole = this._storage.readLocalStorage('userRole');
  }

  closePanel() {
    if (this.statusPanel == 'isVisible' && !this.status) {
      this.statusPanel = VisibleState.isHidden;
    } else {
      this.status = false;
    }
  }

  ngOnInit(){

  }

  signOut(){
    this._auth.logout();
  }

  toggle() {
    this.status = !this.status;
    this.statusPanel = (this.statusPanel == VisibleState.isHidden ? VisibleState.isVisible : VisibleState.isHidden);
  }

  openAccountSettings(){
    this.toggle();
    this.dialogConfirmation = this._dialog.open(DialogAccountSettingsComponent, {
      panelClass: ['custom-mat-dialog','mat-dialog-account'],
    });

    this.dialogConfirmation.afterClosed().subscribe(
      resCode => {
        if (resCode == KeyName.form_submitted) {
          console.log(resCode);
        }
      }
    )

  }

}
